import DayScreenTheme from './theme/DayScreenTheme';
const bold = require('./assets/fonts/ToyotaType-Bold.otf');

export default {
  Fonts: {
    bold,
  },
  Toyota: {
    Day:{...DayScreenTheme},
  },
};
